import type { MediaSchema } from '~/types/schema';

export type UseCategoryMainMedia = {
  media: ComputedRef<MediaSchema>;
  displayType: ComputedRef<
    'center_circle' | 'default' | 'scale_to_fit' | 'dimensionTest_and_result'
  >;
};

export const useCategoryMainMedia = (
  pCategoryDisplayIcon: CategoryDisplayIcon,
  pMedia: Map<string, MediaSchema>
): UseCategoryMainMedia => {
  const { mediaIcon, displayType: categoryDisplayType } = pCategoryDisplayIcon;

  const media = computed(() => {
    return mediaIcon.value ? pMedia.get(mediaIcon.value) : null;
  });

  const isScaleToFitMedia = computed(() => {
    if (media.value && media.value.scaleToFit) return true;
    return false;
  });

  const displayType = computed(() => {
    if (isScaleToFitMedia.value) return 'scale_to_fit';
    return categoryDisplayType.value;
  });

  return {
    media,
    displayType,
  };
};
